<template>
    <v-form v-on:submit.prevent="onSubmit" ref="form" class="mb-5">
        <v-card :color="isAja ? '#1E3945' : ''" >
            <v-card-text>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            v-model="user.lastname"
                            outlined
                            label="Nom"
                            :rules="[rules.required]"
                            :color="isAja ? '#4E983C' : 'primary'"
                        ></v-text-field>

                        <v-text-field
                            v-model="user.firstname"
                            outlined
                            label="Prénom"
                            :rules="[rules.required]"
                            :color="isAja ? '#4E983C' : 'primary'"
                        ></v-text-field>

                        <v-text-field
                            v-model="user.email"
                            outlined
                            label="E-mail"
                            :rules="[rules.required, rules.email]"
                            :color="isAja ? '#4E983C' : 'primary'"
                        ></v-text-field>

                        <date-input 
                            v-model="user.birthdate" 
                            label="Date de naissance" 
                            @save="date => user.birthdate = date"
                            required
                            :color="isAja ? '#4E983C' : 'primary'"
                        />

                        <v-text-field
                            v-model="user.street"
                            outlined
                            label="Adresse"
                            :rules="[rules.required]"
                            hide-details="auto"
                            :color="isAja ? '#4E983C' : 'primary'"
                            class="mb-4"
                        ></v-text-field>

                        <v-row>
                            <v-col cols="12" :md="4">
                                <v-text-field
                                    v-model="user.zip"
                                    outlined
                                    label="Code postal"
                                    :rules="[rules.required]"
                                    @change="fetchCities"
                                    clearable
                                    :color="isAja ? '#4E983C' : 'primary'"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" :md="8">
                                <v-autocomplete
                                    v-if="isFrance"
                                    v-model="user.city"
                                    :items="allCities"
                                    item-text="nom"
                                    item-value="nom"
                                    label="Ville"
                                    :loading="citiesLoading"
                                    :disabled="citiesLoading"
                                    outlined
                                    :rules="[rules.required]"
                                    hide-details="auto"
                                    no-data-text="Aucune ville trouvée"
                                    @change="fetchZip"
                                    return-object
                                    clearable
                                    :color="isAja ? '#4E983C' : 'primary'"
                                ></v-autocomplete>
                                <!-- Pays ≠ France (compte créé par un admin) : le référentiel geo.api.gouv.fr ne s'applique pas, saisie libre -->
                                <v-text-field
                                    v-else
                                    v-model="user.city"
                                    label="Ville"
                                    outlined
                                    :rules="[rules.required]"
                                    hide-details="auto"
                                    clearable
                                    :color="isAja ? '#4E983C' : 'primary'"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-text-field
                            v-model="user.phone"
                            outlined
                            label="Téléphone"
                            :rules="[rules.required]"
                            @input="formatPhone"
                            :color="isAja ? '#4E983C' : 'primary'"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="6">
                        <!-- <div v-if="action == 'create'">
                            <v-text-field
                                v-model="user.password"
                                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                label="Mot de passe"
                                :rules="[rules.required, rules.minlength]"
                                counter
                                @click:append="toggleShowPassword"
                                :type="showPassword ? 'text' : 'password'"
                                hint="8 caractères min."
                            ></v-text-field>

                            <v-text-field
                                v-model="user.confirm"
                                :append-icon="showConfirm ? 'visibility' : 'visibility_off'"
                                label="Confirmation du mot de passe"
                                :rules="[rules.required]"
                                counter
                                @click:append="toggleShowConfirm"
                                :type="showConfirm ? 'text' : 'password'"
                            ></v-text-field>
                        </div> -->

                        <div v-if="action == 'update'">
                            <v-text-field
                                v-model="user.old_password"
                                :append-icon="showOldPassword ? 'visibility' : 'visibility_off'"
                                label="Ancien mot de passe"
                                counter
                                outlined
                                @click:append="showOldPassword = !showOldPassword"
                                :type="showOldPassword ? 'text' : 'password'"
                                :color="isAja ? '#4E983C' : 'primary'"
                            ></v-text-field>

                            <v-text-field
                                v-model="password"
                                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                label="Mot de passe"
                                :rules="[rules.minlength]"
                                counter
                                outlined
                                @click:append="showPassword = !showPassword"
                                :type="showPassword ? 'text' : 'password'"
                                hint="8 caractères min."
                                :color="isAja ? '#4E983C' : 'primary'"
                            ></v-text-field>

                            <v-text-field
                                v-model="confirm"
                                :append-icon="showConfirm ? 'visibility' : 'visibility_off'"
                                label="Confirmation du mot de passe"
                                counter
                                outlined
                                @click:append="showConfirm = !showConfirm"
                                :type="showConfirm ? 'text' : 'password'"
                                :color="isAja ? '#4E983C' : 'primary'"
                            ></v-text-field>
                        </div>

                        <!-- Section Assistant AJA -->
                        <div v-if="isAjaYoung" style="border: 1px solid; border-radius: 10px; padding: 10px;">
                            <h3 class="mb-0">Mon Aidant PAP</h3>
                            
                            <template v-if="user.aja_assistant">
                                <v-card outlined class="mb-4" :color="isAja ? '#1E3945' : ''" dark>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12">
                                                <p class="mb-2"><strong>Nom :</strong> {{ user.aja_assistant.lastname }}</p>
                                                <p class="mb-2"><strong>Prénom :</strong> {{ user.aja_assistant.firstname }}</p>
                                                <p class="mb-2"><strong>Email :</strong> {{ user.aja_assistant.email }}</p>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <ConfirmButton 
                                                    v-if="!user.is_invited"
                                                    buttonText="Supprimer l'aidant"
                                                    headline="Etes-vous sûr de vouloir supprimer votre aidant ? Son compte sera supprimé."
                                                    color="error"
                                                    outlined
                                                    @confirmed="deleteAssistant"
                                                    :loading="deletingAssistant"
                                                />
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </template>
                            <template v-else>
                                <v-card outlined class="mb-4" :color="isAja ? '#1E3945' : ''" dark>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-text-field
                                                    v-model="newAssistant.firstname"
                                                    outlined
                                                    hide-details="auto"
                                                    label="Prénom de l'aidant"
                                                    :rules="[rules.required]"
                                                    :color="isAja ? '#4E983C' : 'primary'"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field
                                                    v-model="newAssistant.lastname"
                                                    outlined
                                                    hide-details="auto"
                                                    label="Nom de l'aidant"
                                                    :rules="[rules.required]"
                                                    :color="isAja ? '#4E983C' : 'primary'"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field
                                                    v-model="newAssistant.email"
                                                    outlined
                                                    hide-details="auto"
                                                    label="Email de l'aidant"
                                                    :rules="[rules.required, rules.email]"
                                                    :color="isAja ? '#4E983C' : 'primary'"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-btn
                                                    :color="isAja ? '#4E983C' : 'primary'"
                                                    outlined
                                                    @click="createAssistant"
                                                    :loading="creatingAssistant"
                                                >
                                                    Ajouter un aidant et lui envoyer un mail d'invitation
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </template>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-row justify="center" class="mt-5">
            <v-btn :color="isAja ? '#4E983C' : 'primary'" type="submit" :disabled="loading" :loading="loading" x-large>Sauvegarder</v-btn>
        </v-row>
    </v-form>
</template>

<script>
import ConfirmButton from '@/components/ConfirmButton'

export default {
    components: {
        ConfirmButton
    },
    props: {
        value: Object,
        action: {
            type: String,
            default: 'update'
        },
    },
    data () {
        return {
            user: Object.assign({}, this.value),
            old_password: '',
            password: '',
            confirm: '',
            showOldPassword: false,
            showPassword: false,
            showConfirm: false,
            updatePassword: false,
            loading: false,
            creatingAssistant: false,
            deletingAssistant: false,
            newAssistant: {},
            rules: {
                required: value => !!value || 'Champ requis',
                minlength: value => !value || (value && value.length >= 8) || '8 caractères min.',
                email: value => /.+@.+\..+/.test(value) || 'Format invalide',
            },
            allCities: [],
            citiesLoading: false,
        }
    },
    watch: {
        user () {
            this.$refs.form.resetValidation()
        },
    },
    mounted() {
        this.fetchCities()
    },
    computed: {
        isAja() {
            return this.$store.getters.getProfile.is_aja
        },
        // country is set by the back-office only (ISO-2, default FR); a missing value is treated as France
        isFrance() {
            return !this.user.country || this.user.country === 'FR'
        },
        isAjaYoung() {
            return this.isAja && this.user.aja_role === 'aja_young'
        }
    },
    methods: {
        formatPhone() {
            this.user.phone = this.user.phone.replace(/\s/g,'').match(/.{1,2}/g).join(' ')
        },
        fetchCities() {
            if (!this.isFrance) {
                return
            }
            this.citiesLoading = true
            let url = 'https://geo.api.gouv.fr/communes'
            if (this.user.zip && this.user.zip.length == 5)
                url += '?codePostal='+this.user.zip
            this.$axios.get(url)
                .then((resp) => {
                    this.allCities = resp.data
                    if (this.allCities.length == 1) {
                        const validZips = this.allCities[0].codesPostaux
                        this.user.city = this.allCities[0].nom
                        if (!validZips.includes(this.user.zip)) {
                            this.user.zip = validZips[0]
                        }
                    }
                }).finally(() => {
                    this.citiesLoading = false
                })
        },
        fetchZip() {
            if (this.user.city && this.user.city.codesPostaux) {
                const validZips = this.user.city.codesPostaux
                if (!validZips.includes(this.user.zip)) {
                    this.user.zip = validZips[0]
                }
                this.user.city = this.user.city.nom
            }
        },
        onSubmit () {
            if (this.$refs.form.validate()) {
                this.loading = true;

                if (this.old_password) {
                    this.user.old_password = this.old_password
                }

                if (this.password && this.confirm) {
                    this.user.password = this.password
                    this.user.password_confirmation = this.confirm
                }

                let request = 'userCreateRequest'
                let queries = this.user

                if (this.action === 'update') {
                    request = 'userEditRequest'
                    queries = {id: this.user.id, datas: this.user}
                }

                this.$store.dispatch(request, queries)
                    .then((user) => {
                        this.$refs.form.resetValidation()
                        this.loading = false;
                        this.$store.dispatch('profileRequest').then(() => {
                            this.$store.commit('setSnack', {'type': 'success', 'msg': 'Utilisateur enregistré !'});
                            this.$router.push({name: user.is_aja ? 'aja-home' : 'home'})
                        })
                    })
                    .catch((err) => {
                        this.loading = false;
                        if (err.response.status != 403)
                            this.$store.dispatch('setErrors', err.response.data)
                    })
            }
        },
        async createAssistant() {
            if (!this.newAssistant.firstname || !this.newAssistant.lastname || !this.newAssistant.email) {
                return
            }
            this.creatingAssistant = true
            try {
                const response = await this.$store.dispatch('createAjaAssistantRequest', {
                    userId: this.user.id,
                    assistantData: this.newAssistant
                })
                this.user.aja_assistant = response.data
                this.newAssistant = {}
                this.$store.commit('setSnack', {'type': 'success', 'msg': 'Aidant ajouté avec succès !'})
            } catch (error) {
                if (error.response.status !== 403) {
                    this.$store.dispatch('setErrors', error.response.data)
                }
            } finally {
                this.creatingAssistant = false
            }
        },
        async deleteAssistant() {
            this.deletingAssistant = true
            try {
                await this.$store.dispatch('deleteAjaAssistantRequest', this.user.id)
                this.user.aja_assistant = null
                this.$store.commit('setSnack', {'type': 'success', 'msg': 'Aidant supprimé avec succès !'})
            } catch (error) {
                if (error.response.status !== 403) {
                    this.$store.dispatch('setErrors', error.response.data)
                }
            } finally {
                this.deletingAssistant = false
            }
        }
    }
}
</script>
